import React, {Component} from "react";
import redirectURL from '../redirectURL'
import Select from 'react-select';
import loginAnimation from '../../assets/animations/login_animation.json'
import enmovilSmallLogo from '../../assets/images/enmovil_small_image.png'
import { PublicClientApplication } from '@azure/msal-browser';
import { msalConfig } from './msalAuthConfig';

class Login extends Component {
    constructor(props) {
        console.log("Login Page constructor");
        super(props);
        this.msalInstance = new PublicClientApplication(msalConfig);
        
        this.state = {
            style: {},
            projects: [],
            project_name: '',
            validationMessage: "",
            isAuthenticated: false,       // NEW: tracks whether SSO login is done
            ssoResponse: null,            // NEW: stores the SSO response after login
            loadshow: 'show-n',
            overly: 'show-n',
            defaultOptions: {
                loop: true,
                autoplay: true,
                animationData: loginAnimation,
                renderSettings: {
                    preserveAspectRatio: 'xMidYMid slice'
                }
            }
        };
    }

    // Step 1: SSO Login — no project list fetched yet, no customer data exposed
    onClickSSOLogin = (event) => {
        event.preventDefault();
        this.msalInstance.loginPopup()
            .then(response => {
                console.log(response, "SSO login success");
                localStorage.setItem("sso_data", JSON.stringify(response));

                // Only AFTER successful SSO do we fetch the customer/project list
                this.fetchProjectsList(response);
            })
            .catch(error => {
                console.error('Login error:', error);
                this.setState({
                    validationMessage: 'Authentication Failed. Please contact Admin.'
                });
            });
    }

    // Fetch projects ONLY after successful SSO authentication
    fetchProjectsList = (ssoResponse) => {
        redirectURL.post("/getprojectsList").then((response) => {
            const data = response.data;
            data.forEach(group => {
                group.projects.sort((a, b) => a.project_name.localeCompare(b.project_name));
            });
            const orderedEnvTypes = ['PROD', 'POC'];
            data.sort((a, b) => {
                const indexA = orderedEnvTypes.indexOf(a.env_type);
                const indexB = orderedEnvTypes.indexOf(b.env_type);
                return indexA - indexB;
            });
            const sortedProjects = data.flatMap(group =>
                group.projects.map(project => ({
                    value: project.project_name,
                    label: project.project_name
                }))
            );
            this.setState({
                projects: sortedProjects,
                isAuthenticated: true,   // Unlock the project dropdown UI
                ssoResponse: ssoResponse,
                validationMessage: ""
            });
        }).catch(error => {
            console.error('Error fetching projects:', error);
            this.setState({
                validationMessage: "Failed to load projects. Please try again."
            });
        });
    }

    // Step 2: Project selection & redirect — called after SSO + project chosen
    onClickLaunchProject = (event) => {
        event.preventDefault();
        if (!this.state.project_name) {
            this.setState({ validationMessage: "Fields marked with * are required!" });
            return;
        }

        const { ssoResponse, project_name } = this.state;
        this.setState({ loadshow: 'show-m', overly: 'show-m', validationMessage: "" });

        // The backend verifies who is launching the project from Microsoft's ID
        // token (ensologin_node routes/identityVerifier.js) instead of trusting
        // the email below. ID tokens last about an hour and the user may sit on
        // this screen longer. The token from the login popup is used as-is while
        // it is still valid (no extra wait before the new tab opens, so popup
        // blockers are not triggered); only an expired one is renewed silently.
        const getIdToken = () => {
            const exp = ssoResponse.idTokenClaims && ssoResponse.idTokenClaims.exp;
            if (ssoResponse.idToken && exp && exp * 1000 > Date.now() + 60000) {
                return Promise.resolve(ssoResponse.idToken);
            }
            return this.msalInstance
                .acquireTokenSilent({ scopes: ["openid", "profile"], account: ssoResponse.account })
                .then(result => (result && result.idToken) || ssoResponse.idToken)
                .catch(() => ssoResponse.idToken);
        };

        getIdToken().then((idToken) => {
        const params = {
            "project_name": project_name.value,
            "username": ssoResponse.account.name,
            "email": ssoResponse.account.username,
            "id_token": idToken || ""
        };

        return redirectURL.post("/getCustomerToken", params).then((response1) => {
            console.log(response1.data, "Customer token response");
            // Fallbacks if properties are missing
            var isAuthRequired = (response1.data && response1.data.is_authentication_required !== undefined)
                ? response1.data.is_authentication_required
                : 0;
            var tokenCallType = (response1.data && response1.data.tokenCallType !== undefined)
                ? response1.data.tokenCallType
                : 1;
            var appUrl = (response1.data && response1.data.app_url) ? response1.data.app_url : "";
            var token = (response1.data && response1.data.token) ? response1.data.token : "";

            var main_link = appUrl + "enmuserlogin/" + token; 
            if (isAuthRequired === 0) {
                this.openInNewTab(appUrl);
            } else {
                if(tokenCallType === 1 || tokenCallType === "1")
                {                    
                    this.openInNewTab(appUrl + "enmuserlogin/" + token);
                    main_link = appUrl + "enmuserlogin/" + token; 
                }
                else
                {
                    this.openInNewTab(appUrl + "enmuserlogin?token=" + token);
                    main_link = appUrl + "enmuserlogin?token=" + token; 
                }
            }
            this.setState({
                main_link: main_link,
                loadshow: 'show-n',
                overly: 'show-n',
            });
        });
        }).catch(error => {
            console.error('Error getting customer token:', error);
            this.setState({
                validationMessage: "Failed to launch project. Please try again.",
                loadshow: 'show-n',
                overly: 'show-n',
            });
        });
    }

    openInNewTab(url) {
        const anchor = document.createElement('a');
        anchor.href = url;
        anchor.target = '_blank';
        document.body.appendChild(anchor);
        anchor.click();
        document.body.removeChild(anchor);
    }

    render() {
        const { isAuthenticated, projects, project_name, validationMessage } = this.state;

        return (
            <div className="main_login">
                <div className="background_wallpaper"></div>
                <div className="card">
                    <img src={enmovilSmallLogo} alt="enmovil_logo" className="enmovil_small_logo"/>

                    {validationMessage && (
                        <div style={{ color: 'red', marginBottom: '10px' }}>
                            {validationMessage}
                        </div>
                    )}

                    {/* STEP 1: Show SSO login button only — no customer data visible */}
                    {!isAuthenticated && (
                        <form
                            method="POST"
                            id="sso_login_form"
                            className="theme-form col-xl-12 col-lg-12"
                            onSubmit={this.onClickSSOLogin}
                        >
                            <div className="col button_switch">
                                <button type="submit" className="btn submit_btn">
                                    Login With M365
                                </button>
                            </div>
                        </form>
                    )}

                    {/* STEP 2: After SSO success, show project dropdown */}
                    {isAuthenticated && (
                        <form
                            method="POST"
                            id="project_select_form"
                            className="theme-form col-xl-12 col-lg-12"
                            onSubmit={this.onClickLaunchProject}
                        >
                            <div className="col-xl-12 col-lg-12 row form-group">
                                <label className="col-xl-12 col-lg-12" style={{ fontWeight: "bold" }}>
                                    Project *
                                </label>
                                <Select
                                    value={project_name}
                                    placeholder={"Select Project Name"}
                                    closeMenuOnSelect={true}
                                    onChange={(e) => this.setState({
                                        project_name: e,
                                        validationMessage: ""
                                    })}
                                    className={"col-xl-12 col-lg-12 border-radius-0"}
                                    options={projects}
                                    required
                                />
                            </div>
                            <div className="col button_switch">
                                <button type="submit" className="btn submit_btn">
                                    Launch Project
                                </button>
                            </div>
                        </form>
                    )}
                </div>
            </div>
        );
    }
}

export default Login;